/**
 * Define all of your application routes here
 * for more information on routes, see the
 * official documentation https://router.vuejs.org/en/
 */

import avaliacoes from "./modulos/avaliacoes";
import eixos from "./modulos/eixos";
import questionarios from "./modulos/questionarios";
import questionariosFormularios from "./modulos/questionariosFormularios";
import questoes from "./modulos/questoes";
import comissoes from "./modulos/comissoes";
import participacoes from "./modulos/participacoes";
import relatorios from "./modulos/relatorios";
import comissaoMembros from "./modulos/comissaoMembros";
import ajuda from "./modulos/ajuda";
import competencias from "./modulos/competencias";
import users from "./modulos/users"

const registroModulos = [
    ajuda,
    avaliacoes,
    comissaoMembros,
    comissoes,
    competencias,
    eixos,
    participacoes,
    questionarios,
    questionariosFormularios,
    questoes,
    relatorios,
    users
];

let paths = [
    {
        path: '',
        name: 'Início',
        view: 'Home'
    },
    {
        path: '/dashboard',
        name: 'Dashboard',
        view: 'Dashboard',
        permissions: null, // Público
    },
    {
        path: '/oauth-redirect',
        name: 'OAuthRedirect',
        view: 'OAuthRedirect',
        permissions: null, // Público
    },
    {
        path: '/auto-open',
        name: 'AutoOpen',
        view: 'AutoOpen',
        permissions: null, // Público
    },
    {
        path: '/anonimato',
        name: 'Anonimato',
        view: 'anonimato/Index',
        permissions: null, // Público
    }
];

registroModulos.forEach(modulo => {
    paths = paths.concat(modulo);
});

export default paths;
